import { Deserializable } from '../../../lib/models/deserializable';

export class FactFind2 implements Deserializable {
  public ApplicationNumber: number;
  public ApplicantPriority1: string;
  public ApplicantPriority2: string;
  public ApplicantPriority3: string;
  public RepaymentTypeCode: string;
  public ReasonForRepaymentType: string;
  public ValuationReportTypeCode: string;
  public EPCRatingCode: string;
  public EPCDateIssued?: Date;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
